setTimeout(() => {
  const scrollContainersRelatedProducts =
    document.querySelectorAll(".scroll-drag");
  let isDown = false;
  let startX, scrollLeft;

  scrollContainersRelatedProducts.forEach((scrollContainer) => {
    scrollContainer.addEventListener("mousedown", (e) => {
      isDown = true;
      e.stopPropagation();
      e.preventDefault();

      scrollContainer.classList.add("active"); // Change cursor to grabbing
      startX = e.pageX - scrollContainer.offsetLeft; // Get mouse starting position
      scrollLeft = scrollContainer.scrollLeft; // Store initial scroll position
    });

    scrollContainer.addEventListener("mouseleave", (e) => {
      isDown = false;
      scrollContainer.classList.remove("active");
      e.stopPropagation();
      e.preventDefault();
    });

    scrollContainer.addEventListener("mouseup", () => {
      isDown = false;
      scrollContainer.classList.remove("active");
    });

    scrollContainer.addEventListener("mousemove", (e) => {
      if (!isDown) return; // Exit if not dragging
      e.preventDefault(); // Prevent text selection
      const x = e.pageX - scrollContainer.offsetLeft; // Current mouse position
      const walk = (x - startX) * 2; // Multiply by 2 for faster scrolling
      scrollContainer.scrollLeft = scrollLeft - walk;
    });
  });
}, 2000);
